import ProxyBase from '../../../../core/proxies/ProxyBase'

class PostLoginProxy extends ProxyBase {
  getFirstLogin(params) {
    return this.get('FirstLogin', params)
  }
}

export default new PostLoginProxy('PostLogin/')
